module.exports = __webpack_public_path__ + "static/roid05_l-0069bfbea3575b2971d7ef698650abc0.png";